// 'session-ended': Identity already ended the session (it rejected a token
// renewal), so the logout sends no end-session request.
export type LogoutReason = 'idle' | 'user' | 'session-ended';

// The cross-tab logout signal is `<timestamp>:<reason>`. The timestamp makes
// every write a new value, so the storage event fires in the other tabs.
export const encodeLogoutSignal = (reason: LogoutReason): string =>
  `${Date.now().toString()}:${reason}`;

// A value without a reason comes from a tab running an older build and means
// a user-initiated sign-out. A value without a usable timestamp is not ours.
export const decodeLogoutSignal = (value: string): LogoutReason | null => {
  const separatorIndex = value.indexOf(':');
  const timestamp =
    separatorIndex === -1 ? value : value.slice(0, separatorIndex);
  const reason = separatorIndex === -1 ? '' : value.slice(separatorIndex + 1);
  const at = Number(timestamp);

  if (!Number.isFinite(at) || at <= 0) {
    return null;
  }

  return reason === 'idle' || reason === 'session-ended' ? reason : 'user';
};
